import "../styles/Carousel.scss";
import { Carousel } from "react-bootstrap";
//import Carousel1 from "../media/carousel_item_1.webp";
import Carousel2 from "../media/carousel_item_2.webp";
import Carousel3 from "../media/carousel_item_3.webp";

export const HomeCarousel = () => {
  return (
    <Carousel>
      {/* <Carousel.Item>
        <img className="d-block w-100" src={Carousel1} alt="First slide" />
        <Carousel.Caption>
          <h2>Wir kümmern uns um Ihre Website</h2>
        </Carousel.Caption>
      </Carousel.Item> */}
      <Carousel.Item>
        <img className="d-block w-100" src={Carousel3} alt="Second slide" />
        <Carousel.Caption className="caption-right">
          <h2>Planung und Installation Ihres Netzwerks</h2>
        </Carousel.Caption>        
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={Carousel2} alt="Third slide" />
        <Carousel.Caption className="caption-right">
          <h2>Konfiguration und Bau Ihres PCs</h2>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};
